module.exports = __webpack_public_path__ + "img/logoprofdstu.c957ea2c.png";